import React, { useEffect, useState } from 'react';
import AuthLayout from '../layout';
import '../../assets/css/sign-up.css';
import logo from '../../assets/img/logo.png';
import logo1 from '../../assets/img/logoVinet.svg';
import loginBG from '../../assets/img/bgLogin.png';

import useIsTouchDevice from '../../common/hooks';

import MenuSignUp from './menu';
import { useQuery } from '../../common/hooks/useQuery';
import PersonalForm from './personal';
import { DEFAULT_REDIRECT_URI } from '../../constants';
import OrganizationForm from './organization';
import ChangeLang from '../change-lang';
import {
  getDemands,
  getFields,
  getNations,
  getProvinces,
  getSupplies,
} from '../../util/APIUtils';
import { GetCurrentLanguage } from '../../util/ChangeLanguage';
import { i18n } from '@lingui/core';
import MenuSignUpMobile from './menuMobile';
const Signup = () => {
  const query = useQuery();
  const type = query.get('type');
  const redirectParam = query.get('redirect');
  document.title = i18n._(`Đăng ký tài khoản VINET`);

  const curLang = GetCurrentLanguage();
  const [fields, setFields] = useState([]);
  const [nations, setNations] = useState([]);

  const isTouchDevice = useIsTouchDevice();
  const [url, setUrl] = useState();
  const [passwordShown, setPasswordShown] = useState(false);
  useEffect(() => {
    getFields().then((response) =>
      response.json().then((res) => {
        setFields(res);
      }),
    );
    getNations().then((response) =>
      response.json().then((res) => {
        setNations(res);
      }),
    );
  }, [type]);
  return (
    <AuthLayout>
      {!isTouchDevice ? (
        <div className="block">
          <div className="w-full md:flex">
            <div className="md:w-2/6 h-full min-h-screen">
              <div className="menu flex justify-end">
                <div className="general">
                  <MenuSignUp redirectParam={redirectParam} type={type} />
                </div>
              </div>
              <div className="w-10/12">
                <a href={DEFAULT_REDIRECT_URI} className="w-full ">
                  <img src={logo} className="w-full md:mb-0 mb-10" alt="" />
                </a>
              </div>
            </div>
            <div
              className="md:w-4/6 h-full min-h-screen"
              style={{ backgroundColor: 'rgba(47, 125, 191, 1)' }}
            >
              <div className="flex justify-end p-4">
                <ChangeLang />
              </div>
              {(!type || type == 1) && (
                <PersonalForm
                  data={{ fields }}
                  redirectParam={redirectParam}
                  lang={curLang}
                />
              )}
              {(type == 2 || type == 3) && (
                <OrganizationForm
                  type={type}
                  redirectParam={redirectParam}
                  data={{ fields, nations }}
                  lang={curLang}
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="block">
          <div className="w-full md:flex">
            <div className="h-full mb-12 relative">
              <div className="flex flex-col">
                <div
                  className="relative h-[200px]"
                  style={{
                    backgroundImage: `url(${loginBG})`,
                    backgroundSize: 'contain',
                  }}
                >
                  <div className="flex justify-center mt-[5rem] py-2 w-full relative">
                    <a href={DEFAULT_REDIRECT_URI}>
                      <img
                        backgroundImage={loginBG}
                        src={logo1}
                        className=" aspect-4/3 w-[166px] h-[61px] mx-auto"
                        alt="Logo VINET"
                      />
                    </a>
                  </div>
                </div>
                <div className="flex justify-end absolute top-2 right-2">
                  <ChangeLang />
                </div>
                <div className="flex w-auto">
                  <div className="general w-full mx-4">
                    <div className="">
                      <MenuSignUpMobile
                        redirectParam={redirectParam}
                        type={type}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="h-full min-h-screen"
              style={{
                backgroundColor: 'rgba(47, 125, 191, 1)',
                borderRadius: '16px 16px 0 0',
              }}
            >
              {(!type || type == 1) && (
                <PersonalForm
                  data={{ fields }}
                  redirectParam={redirectParam}
                  lang={curLang}
                />
              )}
              {(type == 2 || type == 3) && (
                <OrganizationForm
                  type={type}
                  redirectParam={redirectParam}
                  data={{ fields, nations }}
                  lang={curLang}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </AuthLayout>
  );
};

export default Signup;
